import type { ReactElement } from "react";
import { z } from "zod";

export type Option = { label: string | ReactElement<any>; value: string; disabled?: boolean; group?: string };

export type AutocompleteOption = { label: string; value: string; disabled?: boolean; group?: string };

export const mediaAssetTypeSchema = z.enum(["audio", "image", "video", "model"]);

export type MediaAssetType = z.infer<typeof mediaAssetTypeSchema>;

export const mediaAssetSourceSchema = z.enum(["file", "url"]);

export type MediaAssetSource = z.infer<typeof mediaAssetSourceSchema>;

export type BaseMediaAssetValue = {
  source: MediaAssetSource;
};

export type FileMediaAssetValue = BaseMediaAssetValue & {
  source: "file";
  name: string;
  assetId: string;
};

export type UrlMediaAssetValue = BaseMediaAssetValue & {
  source: "url";
  url: string;
};

export type MediaAssetValue = FileMediaAssetValue | UrlMediaAssetValue;

export type ImageAssetValue = MediaAssetValue & {
  width?: number;
  height?: number;
};

export type AudioAssetValue = MediaAssetValue & {
  duration?: number;
};

export type VideoAssetValue = MediaAssetValue & {
  width?: number;
  height?: number;
  duration?: number;
};

export type ModelAssetValue = MediaAssetValue & {
  animationNames: string[];
};
